import employeeClasses from "../../Employee/AddEmployeeDirectory/AddEmployeeDirectory.module.css";
import companyClasses from "../AddNewCompany/AddNewCompany.module.css";
import classes from "./AddNewLocation.module.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useContext } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useState } from "react";
import authContext from "../../../../AuthContext/authContext";
import { useNavigate } from "react-router-dom";
const base_url = process.env.REACT_APP_BASE_URL;
const AddNewLocation = () => {
  const ctx = useContext(authContext);
  const user_id = ctx.userData.user_id;
  const activeCompany = useSelector((state) => state.appData.activeCompany);
  const [IsDisabled, setIsDisabled] = useState(false);
  const navigate = useNavigate();
  const [managers, setManagers] = useState([
    {
      name: "",
      email: "",
      phone: "",
      password: "",
    },
  ]);
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const nameRegExp = /^[A-Za-z\s\-'.]+$/; // Allows letters, spaces, hyphens, apostrophes, and periods
  const locationRegExp = /^(?=.*[a-zA-Z])[a-zA-Z0-9\s\S]*$/;

  const addManager = () => {
    if (managers.length >= 3) {
      toast.warning("Maximum of 3 managers allowed");
      return;
    }
    const newManager = { name: "", email: "", phone: "", password: "" };
    const updatedManagers = [...managers, newManager];
    setManagers(updatedManagers);
    // Update formik values
    formik.setFieldValue('managers', updatedManagers);
  };
const user_type = ctx.userData.user_type;
  const removeManager = (index) => {
    if (managers.length > 1) {
      const newManagers = [...managers];
      newManagers.splice(index, 1);
      setManagers(newManagers);
      // Update formik values
      formik.setFieldValue('managers', newManagers);
    }
  };

  const handleManagerChange = (index, field, value) => {
    const newManagers = [...managers];
    newManagers[index] = {
      ...newManagers[index],
      [field]: value
    };
    setManagers(newManagers);
    // Update formik values
    formik.setFieldValue('managers', newManagers);
    // Manually trigger validation
    formik.setFieldTouched(`managers[${index}].${field}`, true, false);
  };

  const formik = useFormik({
    initialValues: {
      location: "",
      managers: managers,
    },
    enableReinitialize: false,
    validationSchema: Yup.object({
      location: Yup.string()
        .matches(locationRegExp, "Location cannot be a number")
        .required("Please enter company location"),
       managers: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .matches(nameRegExp, "Please enter valid name")
            .required("Please enter company manager name"),
          email: Yup.string()
            .email("Please enter valid email address")
            .required("Please enter email address"),
          phone: Yup.string()
            .matches(phoneRegExp, "Please enter valid phone number")
            .length(10, "Phone number should be of 10 digits")
            .required("Please enter your phone number"),
          password: Yup.string()
            .min(8, "password must be 8 characters long")
            .required("Please enter a password"),
        })
      ),
    }),
    onSubmit: (values) => {
      setIsDisabled(true);
      let reqObj = {
        method: "POST",
        url: `${base_url}/user/locationManager`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${ctx.token}`,
        },
        data: {
          managers: managers,
          user_type: "location",
          created_by: user_id,  
          location: values.location,
          company_id: activeCompany._id,
        },
      };
      axios(reqObj)
        .then((res) => {
          toast.dismiss();
          toast.success("Location created Successfully!!");
          formik.resetForm();
          setIsDisabled(false);
          navigate(user_type==="company" ? "/company" : "/location");
        })
        .catch((err) => {
          console.log(err);
          toast.dismiss();
          toast.error(
            err.response.data.error.message || "Failed to create location"
          );
          setIsDisabled(false);
        });
    },
  });

  return (
    <>
      <div className={classes.mainCont}>
        <h3>Add New Location</h3>
        {/* <div className={classes.topLinks}>
          <div className={tableClass.tableAction}>
            <Link to="/employeeDirectory">
              <img src={require("../../assets/img/copy.png")} />
              <span>Employee Directory</span>
            </Link>
          </div>
          <div className={tableClass.tableAction}>
            <Link to="/location">
              <img src="/static/img/company_black.png" />
              <span>Location</span>
            </Link>
          </div>
        </div> */}

        <form className={classes.FormDiv} onSubmit={formik.handleSubmit}>
          <div className={classes.formGrpOne}>
            <label for="location">Location Name:</label>
            <div>
              <input
                type="text"
                id="location"
                name="location"
                {...formik.getFieldProps("location")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.location && formik.errors.location ? (
                  <div>{formik.errors.location}</div>
                ) : null}
              </span>
            </div>
          </div>

          {/* <div className={classes.formGrp}>
            <label for="manager_name">Location Manager Name:</label>

            <div>
              <input
                type="text"
                id="manager_name"
                name="manager_name"
                {...formik.getFieldProps("manager_name")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.manager_name && formik.errors.manager_name ? (
                  <div>{formik.errors.manager_name}</div>
                ) : null}
              </span>
            </div>
          </div>

          <div className={classes.formGrp}>
            <label for="manager_email">Location Manager Email: </label>

            <div>
              <input
                type="text"
                id="manager_email"
                name="manager_email"
                {...formik.getFieldProps("manager_email")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.manager_email && formik.errors.manager_email ? (
                  <div>{formik.errors.manager_email}</div>
                ) : null}
              </span>
            </div>
          </div>
          <div className={classes.formGrp}>
            <label for="manager_phone">Location Manager Phone:</label>

            <div>
              <input
                type="text"
                id="manager_phone"
                name="manager_phone"
                {...formik.getFieldProps("manager_phone")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.manager_phone && formik.errors.manager_phone ? (
                  <div>{formik.errors.manager_phone}</div>
                ) : null}
              </span>
            </div>
          </div>
          <div className={classes.formGrp}>
            <label for="password">Password:</label>

            <div>
              <input
                type="password"
                id="password"
                name="password"
                {...formik.getFieldProps("password")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.password && formik.errors.password ? (
                  <div>{formik.errors.password}</div>
                ) : null}
              </span>
            </div>
          </div> */}
          <div className={classes.managersSection}>
            <h4>Location</h4>
            {managers.map((manager, index) => (
              <div key={index} className={classes.managerCard}>
                {managers.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeManager(index)}
                    className={companyClasses.removeManagerBtn}
                  >
                    ×
                  </button>
                )}
                <div className={employeeClasses.formGrp}>
                  <label htmlFor={`manager_name_${index}`}>
                    Manager {index + 1} Name: 
                  </label>
                  <div>
                    <input
                      type="text"
                      id={`manager_name_${index}`}
                      name={`managers[${index}].name`}
                      value={manager.name || ''}
                      onChange={(e) =>
                        handleManagerChange(index, "name", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                    />
                    <span className={employeeClasses.profileerrMsg}>
                      {formik.touched.managers?.[index]?.name &&
                      formik.errors.managers?.[index]?.name ? (
                        <div>{formik.errors.managers[index].name}</div>
                      ) : null}
                    </span>
                  </div>
                </div>
                <div className={employeeClasses.formGrp}>
                  <label htmlFor={`manager_email_${index}`}>
                    Manager {index + 1} Email: 
                  </label>
                  <div>
                    <input
                      type="email"
                      id={`manager_email_${index}`}
                      name={`managers[${index}].email`}
                      value={manager.email || ''}
                      onChange={(e) =>
                        handleManagerChange(index, "email", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                    />
                    <span className={employeeClasses.profileerrMsg}>
                      {formik.touched.managers?.[index]?.email &&
                      formik.errors.managers?.[index]?.email ? (
                        <div>{formik.errors.managers[index].email}</div>
                      ) : null}
                    </span>
                  </div>
                </div>
                <div className={employeeClasses.formGrp}>
                  <label htmlFor={`manager_phone_${index}`}>
                    Manager {index + 1} Phone:
                  </label>
                  <div>
                    <input
                      type="text"
                      id={`manager_phone_${index}`}
                      name={`managers[${index}].phone`}
                      value={manager.phone || ''}
                      onChange={(e) =>
                        handleManagerChange(index, "phone", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                    />
                    <span className={employeeClasses.profileerrMsg}>
                      {formik.touched.managers?.[index]?.phone &&
                      formik.errors.managers?.[index]?.phone ? (
                        <div>{formik.errors.managers[index].phone}</div>
                      ) : null}
                    </span>
                  </div>
                </div>
                <div className={employeeClasses.formGrp}>
                  <label htmlFor={`manager_password_${index}`}>
                    Manager {index + 1} Password:
                  </label>
                  <div>
                    <input
                      type="password"
                      id={`manager_password_${index}`}
                      name={`managers[${index}].password`}
                      value={manager.password || ''}
                      onChange={(e) =>
                        handleManagerChange(index, "password", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                    />
                    <span className={employeeClasses.profileerrMsg}>
                      {formik.touched.managers?.[index]?.password &&
                      formik.errors.managers?.[index]?.password ? (
                        <div>{formik.errors.managers[index].password}</div>
                      ) : null}
                    </span>
                  </div>
                </div>
              </div>
            ))}
            {managers.length < 2 && <button
              type="button"
              onClick={addManager}
              disabled={managers.length >= 2}
              className={companyClasses.addManagerBtn}
            >
             Location Manager
            </button>}
          </div>

          <div className={employeeClasses.formBtn}>
            {/* <button className={classes.cancleBtn}>Cancel</button> */}
            <button
              type="submit"
              className={employeeClasses.createBtn}
              disabled={IsDisabled}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddNewLocation;
